import { render, staticRenderFns } from "./scenePlottingClon.vue?vue&type=template&id=3cba169e&scoped=true"
import script from "./scenePlottingClon.vue?vue&type=script&lang=js"
export * from "./scenePlottingClon.vue?vue&type=script&lang=js"
import style0 from "./scenePlottingClon.vue?vue&type=style&index=0&id=3cba169e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba169e",
  null
  
)

export default component.exports